import { useMemo } from 'react';
import CommunicationHistoryTable from '.';
import { Container } from '../styles/CommunicationHistoryTableContainer.styles';

export const CommunicationHistoryTableContainer = ({ data, searchTerm }) => {
  const filteredData = useMemo(
    () => data.filter(d => d.phone_number?.includes(searchTerm)),
    [data, searchTerm],
  );
  return (
    <Container>
      <CommunicationHistoryTable filteredData={filteredData} />
    </Container>
  );
};
